import { GlobalHeader } from "./view/GlobalHeader";
import { SnsChanger } from "./util/SnsChanger";
import { SnsUtil } from "../umadash.js/util/SnsUtil";

const $ = require('jquery');

export class EntryTutorial {

    constructor() {

    }
    
    public run(): void {

        // タブレットの場合はビューポートを書き換え
        if (window['device'].tablet()) {
            $("meta[name=viewport]").attr("content", 'width=1280');
        }

        // Snsをオン
        SnsUtil.enable(
            $('.btnRound--facebook, .btnCircle--facebook'),
            $('.btnRound--twitter, .btnCircle--twitter'),
            $('.btnRound--hatena'),
            $('.btnRound--line')
        );
        GlobalHeader.getInstance();
        SnsChanger.changeShareUrl(true);
    }
}